
/**
 * Montant du Loyer rattaché à un Logement
 */
export class LoyerModel {

    mtLoyerFoyer: number;
}
